/* tslint:disable */
/* eslint-disable */
/**
 * Parameter Manager API
 * Base Parameter manager Resource API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@wemakesoftware.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'passwordConfirmation': string;
}
/**
 * 
 * @export
 * @interface ComparisonResult
 */
export interface ComparisonResult {
    /**
     * 
     * @type {string}
     * @memberof ComparisonResult
     */
    'projectSlug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ComparisonResult
     */
    'valuePresent'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateMasterListDto
 */
export interface CreateMasterListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterListDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterListDto
     */
    'description'?: string;
}
/**
 * $baseProjectId - can be null and if exist then clone the project details into newly created project.
 * @export
 * @interface CreateProjectDto
 */
export interface CreateProjectDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProjectDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProjectDto
     */
    'baseProjectSlug'?: string;
}
/**
 * Ordering id should be starting from - zero (0) and if not set then tab will be added into the end of the list
 * @export
 * @interface CreateProjectTabDto
 */
export interface CreateProjectTabDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProjectTabDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProjectTabDto
     */
    'orderingId'?: number;
}
/**
 * $id - should be NULL when create the Master List.
 * @export
 * @interface MasterListDataDto
 */
export interface MasterListDataDto {
    /**
     * 
     * @type {number}
     * @memberof MasterListDataDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'parameter': string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'units'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'responsible'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDataDto
     */
    'comment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MasterListDataDto
     */
    'duplicatesAllowed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MasterListDataDto
     */
    'orderingId'?: number;
}
/**
 * 
 * @export
 * @interface MasterListDto
 */
export interface MasterListDto {
    /**
     * 
     * @type {number}
     * @memberof MasterListDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterListDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterListDto
     */
    'status'?: MasterListDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MasterListDto
     */
    'date'?: string;
    /**
     * 
     * @type {Array<MasterListDataDto>}
     * @memberof MasterListDto
     */
    'data'?: Array<MasterListDataDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum MasterListDtoStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED',
    Released = 'RELEASED'
}

/**
 * 
 * @export
 * @interface PreLoginDto
 */
export interface PreLoginDto {
    /**
     * 
     * @type {string}
     * @memberof PreLoginDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof PreLoginDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ProjectComparisonDto
 */
export interface ProjectComparisonDto {
    /**
     * 
     * @type {Array<ProjectComparisonRow>}
     * @memberof ProjectComparisonDto
     */
    'comparisonRows'?: Array<ProjectComparisonRow>;
}
/**
 * 
 * @export
 * @interface ProjectComparisonRow
 */
export interface ProjectComparisonRow {
    /**
     * 
     * @type {MasterListDataDto}
     * @memberof ProjectComparisonRow
     */
    'parameter'?: MasterListDataDto;
    /**
     * 
     * @type {Array<ComparisonResult>}
     * @memberof ProjectComparisonRow
     */
    'results'?: Array<ComparisonResult>;
}
/**
 * 
 * @export
 * @interface ProjectDataDto
 */
export interface ProjectDataDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'id': number | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'dataType': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'listenAddress': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'factor'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'bit'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'max'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'saDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'ttDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'projectTabId': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'masterListDataId': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataDto
     */
    'masterListId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'parameter': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'units'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'responsible'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataDto
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface ProjectDataValidationDto
 */
export interface ProjectDataValidationDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectDataValidationDto
     */
    'projectDataId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDataValidationDto
     */
    'projectTabId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataValidationDto
     */
    'fieldName'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ProjectDataValidationDto
     */
    'errorMessageParameters'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataValidationDto
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDataValidationDto
     */
    'errorType'?: ProjectDataValidationDtoErrorTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectDataValidationDtoErrorTypeEnum {
    Error = 'ERROR',
    Warning = 'WARNING'
}

/**
 * 
 * @export
 * @interface ProjectDto
 */
export interface ProjectDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'status': ProjectDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDto
     */
    'lastUsedAddress'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDto
     */
    'masterListId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'version'?: string;
    /**
     * 
     * @type {Array<ProjectDto>}
     * @memberof ProjectDto
     */
    'versions'?: Array<ProjectDto>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ProjectDto
     */
    'metadata'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'masterListChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDto
     */
    'lastSuccessValidateDate'?: string;
    /**
     * 
     * @type {Array<UserDetailsDto>}
     * @memberof ProjectDto
     */
    'members'?: Array<UserDetailsDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectDtoStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED',
    Released = 'RELEASED'
}
/**
    * @export
    * @enum {string}
    */
export enum ProjectDtoMetadataEnum {
    Admin = 'ADMIN',
    RoleSa = 'ROLE_SA',
    RoleTt = 'ROLE_TT',
    Guest = 'GUEST'
}

/**
 * 
 * @export
 * @interface ProjectLogDto
 */
export interface ProjectLogDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectLogDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectLogDto
     */
    'actionType'?: ProjectLogDtoActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectLogDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLogDto
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLogDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectLogDto
     */
    'projectId'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectLogDtoActionTypeEnum {
    Edit = 'EDIT',
    Add = 'ADD',
    Delete = 'DELETE',
    Release = 'RELEASE'
}

/**
 * 
 * @export
 * @interface ProjectTabDto
 */
export interface ProjectTabDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectTabDto
     */
    'id': number | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectTabDto
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTabDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectTabDto
     */
    'searchResultsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTabDto
     */
    'misplacedMasterDataCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectTabDto
     */
    'hidden'?: boolean;
}
/**
 * 
 * @export
 * @interface ProjectTabValidationDto
 */
export interface ProjectTabValidationDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectTabValidationDto
     */
    'projectTabId'?: number;
    /**
     * 
     * @type {Array<ProjectDataValidationDto>}
     * @memberof ProjectTabValidationDto
     */
    'fieldValidationErrors'?: Array<ProjectDataValidationDto>;
}
/**
 * 
 * @export
 * @interface ProjectValidationDto
 */
export interface ProjectValidationDto {
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationDto
     */
    'projectId'?: number;
    /**
     * 
     * @type {Array<ProjectTabDto>}
     * @memberof ProjectValidationDto
     */
    'projectTabs'?: Array<ProjectTabDto>;
    /**
     * 
     * @type {Array<ProjectDataValidationDto>}
     * @memberof ProjectValidationDto
     */
    'generalValidationErrors'?: Array<ProjectDataValidationDto>;
}
/**
 * 
 * @export
 * @interface UserDetailsDto
 */
export interface UserDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'userRole'?: UserDetailsDtoUserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDto
     */
    'status'?: UserDetailsDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UserDetailsDtoUserRoleEnum {
    Admin = 'ADMIN',
    RoleSa = 'ROLE_SA',
    RoleTt = 'ROLE_TT',
    Guest = 'GUEST'
}
/**
    * @export
    * @enum {string}
    */
export enum UserDetailsDtoStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'userRole': UserDtoUserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'status'?: UserDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'passwordConfirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'authenticationToken'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    'passwordChangeRequired'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UserDtoUserRoleEnum {
    Admin = 'ADMIN',
    RoleSa = 'ROLE_SA',
    RoleTt = 'ROLE_TT',
    Guest = 'GUEST'
}
/**
    * @export
    * @enum {string}
    */
export enum UserDtoStatusEnum {
    Active = 'ACTIVE',
    Archived = 'ARCHIVED'
}


/**
 * AuthenticationControllerApi - axios parameter creator
 * @export
 */
export const AuthenticationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthenticationCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/auth-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary logins to the system and gets a JWT token back
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {number} [authCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginToSystem: async (username?: string, password?: string, authCode?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (authCode !== undefined) { 
                localVarFormParams.set('authCode', authCode as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {PreLoginDto} preLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPreLogin: async (preLoginDto: PreLoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preLoginDto' is not null or undefined
            assertParamExists('userPreLogin', 'preLoginDto', preLoginDto)
            const localVarPath = `/api/authentication/pre-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationControllerApi - functional programming interface
 * @export
 */
export const AuthenticationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAuthenticationCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAuthenticationCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary logins to the system and gets a JWT token back
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {number} [authCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginToSystem(username?: string, password?: string, authCode?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginToSystem(username, password, authCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {PreLoginDto} preLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPreLogin(preLoginDto: PreLoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPreLogin(preLoginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationControllerApi - factory interface
 * @export
 */
export const AuthenticationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuthenticationCode(options?: any): AxiosPromise<string> {
            return localVarFp.generateAuthenticationCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary logins to the system and gets a JWT token back
         * @param {string} [username] 
         * @param {string} [password] 
         * @param {number} [authCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginToSystem(username?: string, password?: string, authCode?: number, options?: any): AxiosPromise<string> {
            return localVarFp.loginToSystem(username, password, authCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generates authentication code for the 2-factor auth
         * @param {PreLoginDto} preLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPreLogin(preLoginDto: PreLoginDto, options?: any): AxiosPromise<string> {
            return localVarFp.userPreLogin(preLoginDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationControllerApi - object-oriented interface
 * @export
 * @class AuthenticationControllerApi
 * @extends {BaseAPI}
 */
export class AuthenticationControllerApi extends BaseAPI {
    /**
     * 
     * @summary generates authentication code for the 2-factor auth
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public generateAuthenticationCode(options?: AxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).generateAuthenticationCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary logins to the system and gets a JWT token back
     * @param {string} [username] 
     * @param {string} [password] 
     * @param {number} [authCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public loginToSystem(username?: string, password?: string, authCode?: number, options?: AxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).loginToSystem(username, password, authCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generates authentication code for the 2-factor auth
     * @param {PreLoginDto} preLoginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationControllerApi
     */
    public userPreLogin(preLoginDto: PreLoginDto, options?: AxiosRequestConfig) {
        return AuthenticationControllerApiFp(this.configuration).userPreLogin(preLoginDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterListResourceControllerApi - axios parameter creator
 * @export
 */
export const MasterListResourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary autocomplete search MasterListData by parameter.
         * @param {number} id MasterList Id
         * @param {string} [query] search query for parameter
         * @param {string} [columnList] Comma separated column list {parameter,description}, if not pass then will search on the all which is listed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocompleteSearch: async (id: number, query?: string, columnList?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('autocompleteSearch', 'id', id)
            const localVarPath = `/api/master-lists/{id}/master-list-datas/search`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (columnList !== undefined) {
                localVarQueryParameter['column_list'] = columnList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Master List data.
         * @param {number} id MasterList ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterListData: async (id: number, masterListDataDto: MasterListDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createMasterListData', 'id', id)
            // verify required parameter 'masterListDataDto' is not null or undefined
            assertParamExists('createMasterListData', 'masterListDataDto', masterListDataDto)
            const localVarPath = `/api/master-lists/{id}/master-list-datas/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(masterListDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Master List without data.
         * @param {CreateMasterListDto} createMasterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnlyMasterList: async (createMasterListDto: CreateMasterListDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMasterListDto' is not null or undefined
            assertParamExists('createOnlyMasterList', 'createMasterListDto', createMasterListDto)
            const localVarPath = `/api/master-lists/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMasterListDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete MasterList by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMasterList: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMasterList', 'id', id)
            const localVarPath = `/api/master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete MasterListData by id.
         * @param {number} id MasterList Id
         * @param {number} dataId MasterList Data ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMasterListData: async (id: number, dataId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMasterListData', 'id', id)
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('deleteMasterListData', 'dataId', dataId)
            const localVarPath = `/api/master-lists/{id}/master-list-datas/{dataId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export MasterList data.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMasterList: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportMasterList', 'id', id)
            const localVarPath = `/api/master-lists/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary if query is pass then get the autocomplete master lists , if not return all master lists.
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterList: async (query?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get master list by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterListById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMasterListById', 'id', id)
            const localVarPath = `/api/master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import master List data.
         * @param {number} id MasterList ID
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMasterList: async (id: number, file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('importMasterList', 'id', id)
            const localVarPath = `/api/master-lists/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update MasterList by id.
         * @param {number} id MasterList ID
         * @param {MasterListDto} masterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMasterList: async (id: number, masterListDto: MasterListDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMasterList', 'id', id)
            // verify required parameter 'masterListDto' is not null or undefined
            assertParamExists('updateMasterList', 'masterListDto', masterListDto)
            const localVarPath = `/api/master-lists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(masterListDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update MasterList data by id.
         * @param {number} id MasterList ID
         * @param {number} dataId MasterList Data ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMasterListData: async (id: number, dataId: number, masterListDataDto: MasterListDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMasterListData', 'id', id)
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('updateMasterListData', 'dataId', dataId)
            // verify required parameter 'masterListDataDto' is not null or undefined
            assertParamExists('updateMasterListData', 'masterListDataDto', masterListDataDto)
            const localVarPath = `/api/master-lists/{id}/master-list-datas/{dataId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(masterListDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterListResourceControllerApi - functional programming interface
 * @export
 */
export const MasterListResourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterListResourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary autocomplete search MasterListData by parameter.
         * @param {number} id MasterList Id
         * @param {string} [query] search query for parameter
         * @param {string} [columnList] Comma separated column list {parameter,description}, if not pass then will search on the all which is listed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autocompleteSearch(id: number, query?: string, columnList?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterListDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autocompleteSearch(id, query, columnList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Master List data.
         * @param {number} id MasterList ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMasterListData(id: number, masterListDataDto: MasterListDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMasterListData(id, masterListDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a Master List without data.
         * @param {CreateMasterListDto} createMasterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnlyMasterList(createMasterListDto: CreateMasterListDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOnlyMasterList(createMasterListDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete MasterList by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMasterList(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMasterList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete MasterListData by id.
         * @param {number} id MasterList Id
         * @param {number} dataId MasterList Data ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMasterListData(id: number, dataId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMasterListData(id, dataId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export MasterList data.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMasterList(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMasterList(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary if query is pass then get the autocomplete master lists , if not return all master lists.
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMasterList(query?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMasterList(query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get master list by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMasterListById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMasterListById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Import master List data.
         * @param {number} id MasterList ID
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importMasterList(id: number, file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importMasterList(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update MasterList by id.
         * @param {number} id MasterList ID
         * @param {MasterListDto} masterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMasterList(id: number, masterListDto: MasterListDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMasterList(id, masterListDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update MasterList data by id.
         * @param {number} id MasterList ID
         * @param {number} dataId MasterList Data ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMasterListData(id: number, dataId: number, masterListDataDto: MasterListDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterListDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMasterListData(id, dataId, masterListDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterListResourceControllerApi - factory interface
 * @export
 */
export const MasterListResourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterListResourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary autocomplete search MasterListData by parameter.
         * @param {number} id MasterList Id
         * @param {string} [query] search query for parameter
         * @param {string} [columnList] Comma separated column list {parameter,description}, if not pass then will search on the all which is listed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autocompleteSearch(id: number, query?: string, columnList?: string, options?: any): AxiosPromise<Array<MasterListDataDto>> {
            return localVarFp.autocompleteSearch(id, query, columnList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Master List data.
         * @param {number} id MasterList ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterListData(id: number, masterListDataDto: MasterListDataDto, options?: any): AxiosPromise<MasterListDataDto> {
            return localVarFp.createMasterListData(id, masterListDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Master List without data.
         * @param {CreateMasterListDto} createMasterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnlyMasterList(createMasterListDto: CreateMasterListDto, options?: any): AxiosPromise<MasterListDto> {
            return localVarFp.createOnlyMasterList(createMasterListDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete MasterList by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMasterList(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteMasterList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete MasterListData by id.
         * @param {number} id MasterList Id
         * @param {number} dataId MasterList Data ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMasterListData(id: number, dataId: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteMasterListData(id, dataId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export MasterList data.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMasterList(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.exportMasterList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary if query is pass then get the autocomplete master lists , if not return all master lists.
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterList(query?: string, options?: any): AxiosPromise<Array<MasterListDto>> {
            return localVarFp.getMasterList(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get master list by id.
         * @param {number} id MasterList ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterListById(id: number, options?: any): AxiosPromise<MasterListDto> {
            return localVarFp.getMasterListById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import master List data.
         * @param {number} id MasterList ID
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMasterList(id: number, file?: any, options?: any): AxiosPromise<MasterListDto> {
            return localVarFp.importMasterList(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update MasterList by id.
         * @param {number} id MasterList ID
         * @param {MasterListDto} masterListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMasterList(id: number, masterListDto: MasterListDto, options?: any): AxiosPromise<MasterListDto> {
            return localVarFp.updateMasterList(id, masterListDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update MasterList data by id.
         * @param {number} id MasterList ID
         * @param {number} dataId MasterList Data ID
         * @param {MasterListDataDto} masterListDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMasterListData(id: number, dataId: number, masterListDataDto: MasterListDataDto, options?: any): AxiosPromise<MasterListDataDto> {
            return localVarFp.updateMasterListData(id, dataId, masterListDataDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterListResourceControllerApi - object-oriented interface
 * @export
 * @class MasterListResourceControllerApi
 * @extends {BaseAPI}
 */
export class MasterListResourceControllerApi extends BaseAPI {
    /**
     * 
     * @summary autocomplete search MasterListData by parameter.
     * @param {number} id MasterList Id
     * @param {string} [query] search query for parameter
     * @param {string} [columnList] Comma separated column list {parameter,description}, if not pass then will search on the all which is listed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public autocompleteSearch(id: number, query?: string, columnList?: string, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).autocompleteSearch(id, query, columnList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Master List data.
     * @param {number} id MasterList ID
     * @param {MasterListDataDto} masterListDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public createMasterListData(id: number, masterListDataDto: MasterListDataDto, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).createMasterListData(id, masterListDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Master List without data.
     * @param {CreateMasterListDto} createMasterListDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public createOnlyMasterList(createMasterListDto: CreateMasterListDto, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).createOnlyMasterList(createMasterListDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete MasterList by id.
     * @param {number} id MasterList ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public deleteMasterList(id: number, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).deleteMasterList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete MasterListData by id.
     * @param {number} id MasterList Id
     * @param {number} dataId MasterList Data ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public deleteMasterListData(id: number, dataId: number, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).deleteMasterListData(id, dataId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export MasterList data.
     * @param {number} id MasterList ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public exportMasterList(id: number, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).exportMasterList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary if query is pass then get the autocomplete master lists , if not return all master lists.
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public getMasterList(query?: string, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).getMasterList(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get master list by id.
     * @param {number} id MasterList ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public getMasterListById(id: number, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).getMasterListById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import master List data.
     * @param {number} id MasterList ID
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public importMasterList(id: number, file?: any, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).importMasterList(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update MasterList by id.
     * @param {number} id MasterList ID
     * @param {MasterListDto} masterListDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public updateMasterList(id: number, masterListDto: MasterListDto, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).updateMasterList(id, masterListDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update MasterList data by id.
     * @param {number} id MasterList ID
     * @param {number} dataId MasterList Data ID
     * @param {MasterListDataDto} masterListDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterListResourceControllerApi
     */
    public updateMasterListData(id: number, dataId: number, masterListDataDto: MasterListDataDto, options?: AxiosRequestConfig) {
        return MasterListResourceControllerApiFp(this.configuration).updateMasterListData(id, dataId, masterListDataDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectComparisonControllerApi - axios parameter creator
 * @export
 */
export const ProjectComparisonControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Compares project based on master list
         * @param {Array<string>} slugs Project slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProjects: async (slugs: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slugs' is not null or undefined
            assertParamExists('compareProjects', 'slugs', slugs)
            const localVarPath = `/api/projects/compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (slugs) {
                localVarQueryParameter['slugs'] = slugs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectComparisonControllerApi - functional programming interface
 * @export
 */
export const ProjectComparisonControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectComparisonControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Compares project based on master list
         * @param {Array<string>} slugs Project slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareProjects(slugs: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectComparisonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareProjects(slugs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectComparisonControllerApi - factory interface
 * @export
 */
export const ProjectComparisonControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectComparisonControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Compares project based on master list
         * @param {Array<string>} slugs Project slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareProjects(slugs: Array<string>, options?: any): AxiosPromise<ProjectComparisonDto> {
            return localVarFp.compareProjects(slugs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectComparisonControllerApi - object-oriented interface
 * @export
 * @class ProjectComparisonControllerApi
 * @extends {BaseAPI}
 */
export class ProjectComparisonControllerApi extends BaseAPI {
    /**
     * 
     * @summary Compares project based on master list
     * @param {Array<string>} slugs Project slugs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectComparisonControllerApi
     */
    public compareProjects(slugs: Array<string>, options?: AxiosRequestConfig) {
        return ProjectComparisonControllerApiFp(this.configuration).compareProjects(slugs, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectResourceControllerApi - axios parameter creator
 * @export
 */
export const ProjectResourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary bulk delete project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDelete: async (slug: string, tabSlug: string, requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('bulkDelete', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('bulkDelete', 'tabSlug', tabSlug)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDelete', 'requestBody', requestBody)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/bulk/delete`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary bulk insert project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<ProjectDataDto>} projectDataDto 
         * @param {number} [insertRow] Optional row number to insert the record to
         * @param {string} [pasteProjectSlug] Optional Paste project slug [must set when cut&amp;Paste on different project.]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInsert: async (slug: string, tabSlug: string, projectDataDto: Array<ProjectDataDto>, insertRow?: number, pasteProjectSlug?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('bulkInsert', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('bulkInsert', 'tabSlug', tabSlug)
            // verify required parameter 'projectDataDto' is not null or undefined
            assertParamExists('bulkInsert', 'projectDataDto', projectDataDto)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/bulk/insert`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (insertRow !== undefined) {
                localVarQueryParameter['insertRow'] = insertRow;
            }

            if (pasteProjectSlug !== undefined) {
                localVarQueryParameter['pasteProjectSlug'] = pasteProjectSlug;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Project.
         * @param {CreateProjectDto} createProjectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (createProjectDto: CreateProjectDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProjectDto' is not null or undefined
            assertParamExists('createProject', 'createProjectDto', createProjectDto)
            const localVarPath = `/api/projects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create Project Data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {number} [insertRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectData: async (slug: string, tabSlug: string, projectDataDto: ProjectDataDto, insertRow?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('createProjectData', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('createProjectData', 'tabSlug', tabSlug)
            // verify required parameter 'projectDataDto' is not null or undefined
            assertParamExists('createProjectData', 'projectDataDto', projectDataDto)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/data`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (insertRow !== undefined) {
                localVarQueryParameter['insertRow'] = insertRow;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create Project tab
         * @param {string} slug Project slug
         * @param {CreateProjectTabDto} createProjectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectTab: async (slug: string, createProjectTabDto: CreateProjectTabDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('createProjectTab', 'slug', slug)
            // verify required parameter 'createProjectTabDto' is not null or undefined
            assertParamExists('createProjectTab', 'createProjectTabDto', createProjectTabDto)
            const localVarPath = `/api/projects/{slug}/tabs`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectTabDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete Project Data.
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectData: async (id: number, slug: string, tabSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProjectData', 'id', id)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('deleteProjectData', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('deleteProjectData', 'tabSlug', tabSlug)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/data/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete Project Tab.
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectTab: async (slug: string, tabSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('deleteProjectTab', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('deleteProjectTab', 'tabSlug', tabSlug)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export the project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProject: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('exportProject', 'slug', slug)
            const localVarPath = `/api/projects/{slug}/export`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary return all Project Meta Data Columns enum list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectMetaDataColumns: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/projects/getAllProjectMetaDataColumns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Project by Slug.
         * @param {string} slug Project Slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectBySlug: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getProjectBySlug', 'slug', slug)
            const localVarPath = `/api/projects/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all change history of the project.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLogs: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getProjectLogs', 'slug', slug)
            const localVarPath = `/api/projects/{slug}/logs`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get All Projects list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ordering Project Tab
         * @param {string} slug Project slug
         * @param {Array<ProjectTabDto>} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderingProjectTab: async (slug: string, projectTabDto: Array<ProjectTabDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('orderingProjectTab', 'slug', slug)
            // verify required parameter 'projectTabDto' is not null or undefined
            assertParamExists('orderingProjectTab', 'projectTabDto', projectTabDto)
            const localVarPath = `/api/projects/{slug}/tabs/ordering`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectTabDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary release Project with version
         * @param {string} slug Project slug
         * @param {string} version Project release version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseProject: async (slug: string, version: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('releaseProject', 'slug', slug)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('releaseProject', 'version', version)
            const localVarPath = `/api/projects/{slug}/release/{version}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary autocomplete search projects by name.
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProject: async (query: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchProject', 'query', query)
            const localVarPath = `/api/projects/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary search projectData by given column_list according to the project tab slug
         * @param {string} slug Project Slug
         * @param {string} tabSlug Tab slug
         * @param {string} [query] search query, if not set then return all the ProjectData under the tab.
         * @param {string} [columnList] Comma separated column list, case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectData: async (slug: string, tabSlug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('searchProjectData', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('searchProjectData', 'tabSlug', tabSlug)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/search`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (columnList !== undefined) {
                localVarQueryParameter['column_list'] = columnList;
            }

            if (viewRole !== undefined) {
                localVarQueryParameter['view_role'] = viewRole;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary search projectTab by given column_list according project slug
         * @param {string} slug Project Slug
         * @param {string} [query] search query, if not set then return all the ProjectTabs under the project.
         * @param {string} [columnList] Comma separated column list and case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectTabs: async (slug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('searchProjectTabs', 'slug', slug)
            const localVarPath = `/api/projects/{slug}/tabs/search`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (columnList !== undefined) {
                localVarQueryParameter['column_list'] = columnList;
            }

            if (viewRole !== undefined) {
                localVarQueryParameter['view_role'] = viewRole;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Project by slug
         * @param {string} slug Project slug
         * @param {ProjectDto} projectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (slug: string, projectDto: ProjectDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('updateProject', 'slug', slug)
            // verify required parameter 'projectDto' is not null or undefined
            assertParamExists('updateProject', 'projectDto', projectDto)
            const localVarPath = `/api/projects/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Project Data
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectData: async (id: number, slug: string, tabSlug: string, projectDataDto: ProjectDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProjectData', 'id', id)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('updateProjectData', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('updateProjectData', 'tabSlug', tabSlug)
            // verify required parameter 'projectDataDto' is not null or undefined
            assertParamExists('updateProjectData', 'projectDataDto', projectDataDto)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/data/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update Project Tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectTabDto} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectTab: async (slug: string, tabSlug: string, projectTabDto: ProjectTabDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('updateProjectTab', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('updateProjectTab', 'tabSlug', tabSlug)
            // verify required parameter 'projectTabDto' is not null or undefined
            assertParamExists('updateProjectTab', 'projectTabDto', projectTabDto)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectTabDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProject: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('validateProject', 'slug', slug)
            const localVarPath = `/api/projects/{slug}/validate`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate project tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProjectTab: async (slug: string, tabSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('validateProjectTab', 'slug', slug)
            // verify required parameter 'tabSlug' is not null or undefined
            assertParamExists('validateProjectTab', 'tabSlug', tabSlug)
            const localVarPath = `/api/projects/{slug}/tabs/{tabSlug}/validate`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)))
                .replace(`{${"tabSlug"}}`, encodeURIComponent(String(tabSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectResourceControllerApi - functional programming interface
 * @export
 */
export const ProjectResourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectResourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary bulk delete project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDelete(slug: string, tabSlug: string, requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDelete(slug, tabSlug, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary bulk insert project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<ProjectDataDto>} projectDataDto 
         * @param {number} [insertRow] Optional row number to insert the record to
         * @param {string} [pasteProjectSlug] Optional Paste project slug [must set when cut&amp;Paste on different project.]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkInsert(slug: string, tabSlug: string, projectDataDto: Array<ProjectDataDto>, insertRow?: number, pasteProjectSlug?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkInsert(slug, tabSlug, projectDataDto, insertRow, pasteProjectSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new Project.
         * @param {CreateProjectDto} createProjectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(createProjectDto: CreateProjectDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(createProjectDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create Project Data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {number} [insertRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectData(slug: string, tabSlug: string, projectDataDto: ProjectDataDto, insertRow?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectData(slug, tabSlug, projectDataDto, insertRow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create Project tab
         * @param {string} slug Project slug
         * @param {CreateProjectTabDto} createProjectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectTab(slug: string, createProjectTabDto: CreateProjectTabDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTabDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectTab(slug, createProjectTabDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete Project Data.
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectData(id: number, slug: string, tabSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectData(id, slug, tabSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete Project Tab.
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProjectTab(slug: string, tabSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProjectTab(slug, tabSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export the project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProject(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProject(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary return all Project Meta Data Columns enum list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectMetaDataColumns(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectMetaDataColumns(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get Project by Slug.
         * @param {string} slug Project Slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectBySlug(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectBySlug(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get all change history of the project.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectLogs(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectLogs(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get All Projects list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjects(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ordering Project Tab
         * @param {string} slug Project slug
         * @param {Array<ProjectTabDto>} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderingProjectTab(slug: string, projectTabDto: Array<ProjectTabDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderingProjectTab(slug, projectTabDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary release Project with version
         * @param {string} slug Project slug
         * @param {string} version Project release version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseProject(slug: string, version: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseProject(slug, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary autocomplete search projects by name.
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProject(query: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProject(query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary search projectData by given column_list according to the project tab slug
         * @param {string} slug Project Slug
         * @param {string} tabSlug Tab slug
         * @param {string} [query] search query, if not set then return all the ProjectData under the tab.
         * @param {string} [columnList] Comma separated column list, case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProjectData(slug: string, tabSlug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProjectData(slug, tabSlug, query, columnList, viewRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary search projectTab by given column_list according project slug
         * @param {string} slug Project Slug
         * @param {string} [query] search query, if not set then return all the ProjectTabs under the project.
         * @param {string} [columnList] Comma separated column list and case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProjectTabs(slug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectTabDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProjectTabs(slug, query, columnList, viewRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Project by slug
         * @param {string} slug Project slug
         * @param {ProjectDto} projectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(slug: string, projectDto: ProjectDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(slug, projectDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Project Data
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectData(id: number, slug: string, tabSlug: string, projectDataDto: ProjectDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectData(id, slug, tabSlug, projectDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update Project Tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectTabDto} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectTab(slug: string, tabSlug: string, projectTabDto: ProjectTabDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTabDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectTab(slug, tabSlug, projectTabDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProject(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectValidationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProject(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate project tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProjectTab(slug: string, tabSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTabValidationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProjectTab(slug, tabSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectResourceControllerApi - factory interface
 * @export
 */
export const ProjectResourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectResourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary bulk delete project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDelete(slug: string, tabSlug: string, requestBody: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.bulkDelete(slug, tabSlug, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary bulk insert project data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {Array<ProjectDataDto>} projectDataDto 
         * @param {number} [insertRow] Optional row number to insert the record to
         * @param {string} [pasteProjectSlug] Optional Paste project slug [must set when cut&amp;Paste on different project.]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInsert(slug: string, tabSlug: string, projectDataDto: Array<ProjectDataDto>, insertRow?: number, pasteProjectSlug?: string, options?: any): AxiosPromise<Array<ProjectDataDto>> {
            return localVarFp.bulkInsert(slug, tabSlug, projectDataDto, insertRow, pasteProjectSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Project.
         * @param {CreateProjectDto} createProjectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(createProjectDto: CreateProjectDto, options?: any): AxiosPromise<ProjectDto> {
            return localVarFp.createProject(createProjectDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create Project Data
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {number} [insertRow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectData(slug: string, tabSlug: string, projectDataDto: ProjectDataDto, insertRow?: number, options?: any): AxiosPromise<ProjectDataDto> {
            return localVarFp.createProjectData(slug, tabSlug, projectDataDto, insertRow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create Project tab
         * @param {string} slug Project slug
         * @param {CreateProjectTabDto} createProjectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectTab(slug: string, createProjectTabDto: CreateProjectTabDto, options?: any): AxiosPromise<ProjectTabDto> {
            return localVarFp.createProjectTab(slug, createProjectTabDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete Project Data.
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectData(id: number, slug: string, tabSlug: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectData(id, slug, tabSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete Project Tab.
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectTab(slug: string, tabSlug: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteProjectTab(slug, tabSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export the project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProject(slug: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportProject(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary return all Project Meta Data Columns enum list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectMetaDataColumns(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllProjectMetaDataColumns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Project by Slug.
         * @param {string} slug Project Slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectBySlug(slug: string, options?: any): AxiosPromise<ProjectDto> {
            return localVarFp.getProjectBySlug(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all change history of the project.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLogs(slug: string, options?: any): AxiosPromise<Array<ProjectLogDto>> {
            return localVarFp.getProjectLogs(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get All Projects list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options?: any): AxiosPromise<Array<ProjectDto>> {
            return localVarFp.getProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ordering Project Tab
         * @param {string} slug Project slug
         * @param {Array<ProjectTabDto>} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderingProjectTab(slug: string, projectTabDto: Array<ProjectTabDto>, options?: any): AxiosPromise<string> {
            return localVarFp.orderingProjectTab(slug, projectTabDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary release Project with version
         * @param {string} slug Project slug
         * @param {string} version Project release version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseProject(slug: string, version: string, options?: any): AxiosPromise<ProjectDto> {
            return localVarFp.releaseProject(slug, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary autocomplete search projects by name.
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProject(query: string, options?: any): AxiosPromise<Array<ProjectDto>> {
            return localVarFp.searchProject(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary search projectData by given column_list according to the project tab slug
         * @param {string} slug Project Slug
         * @param {string} tabSlug Tab slug
         * @param {string} [query] search query, if not set then return all the ProjectData under the tab.
         * @param {string} [columnList] Comma separated column list, case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectData(slug: string, tabSlug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: any): AxiosPromise<Array<ProjectDataDto>> {
            return localVarFp.searchProjectData(slug, tabSlug, query, columnList, viewRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary search projectTab by given column_list according project slug
         * @param {string} slug Project Slug
         * @param {string} [query] search query, if not set then return all the ProjectTabs under the project.
         * @param {string} [columnList] Comma separated column list and case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
         * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectTabs(slug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: any): AxiosPromise<Array<ProjectTabDto>> {
            return localVarFp.searchProjectTabs(slug, query, columnList, viewRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Project by slug
         * @param {string} slug Project slug
         * @param {ProjectDto} projectDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(slug: string, projectDto: ProjectDto, options?: any): AxiosPromise<ProjectDto> {
            return localVarFp.updateProject(slug, projectDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Project Data
         * @param {number} id Project Data Id
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectDataDto} projectDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectData(id: number, slug: string, tabSlug: string, projectDataDto: ProjectDataDto, options?: any): AxiosPromise<ProjectDataDto> {
            return localVarFp.updateProjectData(id, slug, tabSlug, projectDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update Project Tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {ProjectTabDto} projectTabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectTab(slug: string, tabSlug: string, projectTabDto: ProjectTabDto, options?: any): AxiosPromise<ProjectTabDto> {
            return localVarFp.updateProjectTab(slug, tabSlug, projectTabDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate project
         * @param {string} slug Project slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProject(slug: string, options?: any): AxiosPromise<ProjectValidationDto> {
            return localVarFp.validateProject(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate project tab
         * @param {string} slug Project slug
         * @param {string} tabSlug Tab slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProjectTab(slug: string, tabSlug: string, options?: any): AxiosPromise<ProjectTabValidationDto> {
            return localVarFp.validateProjectTab(slug, tabSlug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectResourceControllerApi - object-oriented interface
 * @export
 * @class ProjectResourceControllerApi
 * @extends {BaseAPI}
 */
export class ProjectResourceControllerApi extends BaseAPI {
    /**
     * 
     * @summary bulk delete project data
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public bulkDelete(slug: string, tabSlug: string, requestBody: Array<number>, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).bulkDelete(slug, tabSlug, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary bulk insert project data
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {Array<ProjectDataDto>} projectDataDto 
     * @param {number} [insertRow] Optional row number to insert the record to
     * @param {string} [pasteProjectSlug] Optional Paste project slug [must set when cut&amp;Paste on different project.]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public bulkInsert(slug: string, tabSlug: string, projectDataDto: Array<ProjectDataDto>, insertRow?: number, pasteProjectSlug?: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).bulkInsert(slug, tabSlug, projectDataDto, insertRow, pasteProjectSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Project.
     * @param {CreateProjectDto} createProjectDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public createProject(createProjectDto: CreateProjectDto, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).createProject(createProjectDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create Project Data
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {ProjectDataDto} projectDataDto 
     * @param {number} [insertRow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public createProjectData(slug: string, tabSlug: string, projectDataDto: ProjectDataDto, insertRow?: number, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).createProjectData(slug, tabSlug, projectDataDto, insertRow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create Project tab
     * @param {string} slug Project slug
     * @param {CreateProjectTabDto} createProjectTabDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public createProjectTab(slug: string, createProjectTabDto: CreateProjectTabDto, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).createProjectTab(slug, createProjectTabDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete Project Data.
     * @param {number} id Project Data Id
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public deleteProjectData(id: number, slug: string, tabSlug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).deleteProjectData(id, slug, tabSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete Project Tab.
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public deleteProjectTab(slug: string, tabSlug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).deleteProjectTab(slug, tabSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export the project
     * @param {string} slug Project slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public exportProject(slug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).exportProject(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary return all Project Meta Data Columns enum list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public getAllProjectMetaDataColumns(options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).getAllProjectMetaDataColumns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Project by Slug.
     * @param {string} slug Project Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public getProjectBySlug(slug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).getProjectBySlug(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all change history of the project.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public getProjectLogs(slug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).getProjectLogs(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get All Projects list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public getProjects(options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).getProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ordering Project Tab
     * @param {string} slug Project slug
     * @param {Array<ProjectTabDto>} projectTabDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public orderingProjectTab(slug: string, projectTabDto: Array<ProjectTabDto>, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).orderingProjectTab(slug, projectTabDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary release Project with version
     * @param {string} slug Project slug
     * @param {string} version Project release version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public releaseProject(slug: string, version: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).releaseProject(slug, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary autocomplete search projects by name.
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public searchProject(query: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).searchProject(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary search projectData by given column_list according to the project tab slug
     * @param {string} slug Project Slug
     * @param {string} tabSlug Tab slug
     * @param {string} [query] search query, if not set then return all the ProjectData under the tab.
     * @param {string} [columnList] Comma separated column list, case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
     * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public searchProjectData(slug: string, tabSlug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).searchProjectData(slug, tabSlug, query, columnList, viewRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary search projectTab by given column_list according project slug
     * @param {string} slug Project Slug
     * @param {string} [query] search query, if not set then return all the ProjectTabs under the project.
     * @param {string} [columnList] Comma separated column list and case-sensitive, if not set then take it as all columns list and if the query is numeric then only filtered Numeric Columns.
     * @param {'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST'} [viewRole] Impersonate Role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public searchProjectTabs(slug: string, query?: string, columnList?: string, viewRole?: 'ADMIN' | 'ROLE_SA' | 'ROLE_TT' | 'GUEST', options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).searchProjectTabs(slug, query, columnList, viewRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Project by slug
     * @param {string} slug Project slug
     * @param {ProjectDto} projectDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public updateProject(slug: string, projectDto: ProjectDto, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).updateProject(slug, projectDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Project Data
     * @param {number} id Project Data Id
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {ProjectDataDto} projectDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public updateProjectData(id: number, slug: string, tabSlug: string, projectDataDto: ProjectDataDto, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).updateProjectData(id, slug, tabSlug, projectDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update Project Tab
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {ProjectTabDto} projectTabDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public updateProjectTab(slug: string, tabSlug: string, projectTabDto: ProjectTabDto, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).updateProjectTab(slug, tabSlug, projectTabDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate project
     * @param {string} slug Project slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public validateProject(slug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).validateProject(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate project tab
     * @param {string} slug Project slug
     * @param {string} tabSlug Tab slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectResourceControllerApi
     */
    public validateProjectTab(slug: string, tabSlug: string, options?: AxiosRequestConfig) {
        return ProjectResourceControllerApiFp(this.configuration).validateProjectTab(slug, tabSlug, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserResourceControllerApi - axios parameter creator
 * @export
 */
export const UserResourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary change the password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordForUser: async (changePasswordDto: ChangePasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('changePasswordForUser', 'changePasswordDto', changePasswordDto)
            const localVarPath = `/api/users/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new User.
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (userDto: UserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('createUser', 'userDto', userDto)
            const localVarPath = `/api/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get User by Username.
         * @param {string} username Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserByUsername', 'username', username)
            const localVarPath = `/api/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get All User list.
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (searchQuery?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary refreshes the JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshJwt: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update User by username
         * @param {string} username username
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (username: string, userDto: UserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('updateUser', 'username', username)
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('updateUser', 'userDto', userDto)
            const localVarPath = `/api/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-key required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserResourceControllerApi - functional programming interface
 * @export
 */
export const UserResourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserResourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary change the password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePasswordForUser(changePasswordDto: ChangePasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePasswordForUser(changePasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new User.
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(userDto: UserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(userDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get User by Username.
         * @param {string} username Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByUsername(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByUsername(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get All User list.
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(searchQuery?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(searchQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary refreshes the JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshJwt(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshJwt(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update User by username
         * @param {string} username username
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(username: string, userDto: UserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(username, userDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserResourceControllerApi - factory interface
 * @export
 */
export const UserResourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserResourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary change the password
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordForUser(changePasswordDto: ChangePasswordDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.changePasswordForUser(changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new User.
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userDto: UserDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.createUser(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get current user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: any): AxiosPromise<UserDto> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get User by Username.
         * @param {string} username Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername(username: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.getUserByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get All User list.
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(searchQuery?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.getUsers(searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary refreshes the JWT token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshJwt(options?: any): AxiosPromise<string> {
            return localVarFp.refreshJwt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update User by username
         * @param {string} username username
         * @param {UserDto} userDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(username: string, userDto: UserDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.updateUser(username, userDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserResourceControllerApi - object-oriented interface
 * @export
 * @class UserResourceControllerApi
 * @extends {BaseAPI}
 */
export class UserResourceControllerApi extends BaseAPI {
    /**
     * 
     * @summary change the password
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public changePasswordForUser(changePasswordDto: ChangePasswordDto, options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).changePasswordForUser(changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new User.
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public createUser(userDto: UserDto, options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).createUser(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get current user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public getProfile(options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get User by Username.
     * @param {string} username Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public getUserByUsername(username: string, options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).getUserByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get All User list.
     * @param {string} [searchQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public getUsers(searchQuery?: string, options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).getUsers(searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary refreshes the JWT token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public refreshJwt(options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).refreshJwt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update User by username
     * @param {string} username username
     * @param {UserDto} userDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserResourceControllerApi
     */
    public updateUser(username: string, userDto: UserDto, options?: AxiosRequestConfig) {
        return UserResourceControllerApiFp(this.configuration).updateUser(username, userDto, options).then((request) => request(this.axios, this.basePath));
    }
}


